/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MatrixCarePatientDetails } from './MatrixCarePatientDetails';
import {
    MatrixCarePatientDetailsFromJSON,
    MatrixCarePatientDetailsFromJSONTyped,
    MatrixCarePatientDetailsToJSON,
} from './MatrixCarePatientDetails';

/**
 * 
 * @export
 * @interface FindOneMatrixCarePatientDetails200Response
 */
export interface FindOneMatrixCarePatientDetails200Response {
    /**
     * 
     * @type {MatrixCarePatientDetails}
     * @memberof FindOneMatrixCarePatientDetails200Response
     */
    data?: MatrixCarePatientDetails;
}

/**
 * Check if a given object implements the FindOneMatrixCarePatientDetails200Response interface.
 */
export function instanceOfFindOneMatrixCarePatientDetails200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindOneMatrixCarePatientDetails200ResponseFromJSON(json: any): FindOneMatrixCarePatientDetails200Response {
    return FindOneMatrixCarePatientDetails200ResponseFromJSONTyped(json, false);
}

export function FindOneMatrixCarePatientDetails200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOneMatrixCarePatientDetails200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : MatrixCarePatientDetailsFromJSON(json['data']),
    };
}

export function FindOneMatrixCarePatientDetails200ResponseToJSON(value?: FindOneMatrixCarePatientDetails200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': MatrixCarePatientDetailsToJSON(value.data),
    };
}

